// APPLICATION
export const GET_APPLICATION = "GET_APPLICATION";
export const SET_APPLICATION_LOADING_TRUE = "SET_APPLICATION_LOADING_TRUE";
export const SET_APPLICATION_LOADING_FALSE = "SET_APPLICATION_LOADING_FALSE";